package com.macrofocus.eflux.components.link

import kotlinx.browser.window
import mui.material.Button
import mui.material.Link
import mui.system.sx
import react.FC
import react.Props
import web.cssom.None
import web.cssom.px
import web.url.URL

external interface tDMSLinkProps : Props {
    var url: String?
    var link: Boolean?
}

val tDMSLink = FC<tDMSLinkProps> { props ->
    Link {
        sx {
            textTransform = None.none
            paddingTop = 0.px
            paddingBottom = 0.px
        }

        if(props.link != true) {
            component = Button
        } else {
            href = props.url
        }
        onClick = {
            if (props.url != null) {
                window.open(props.url!!, "_blank")
            }
        }

        if (props.link == true) {
            +nthPathSegment(props.url, 3)
        } else {
            +"tDMS"
        }
    }
}

fun nthPathSegment(urlString: String?, n: Int): String? {
    if(urlString == null) return null
    val url = URL(urlString)
    val segments = url.pathname
        .trim('/')
        .split('/')
        .filter { it.isNotEmpty() }

    return segments.getOrNull(n - 1) // n is 1-based
}